<template>
  <div class="container">

    <div class="columns">

      <!-- MAIN CONTENT -->
      <div class="column col-9">
        <div v-if="doc">
          <docMakerSection v-for="(s, i) in doc.sections" v-bind:key="i" :section="s" style="margin-bottom:10px;"></docMakerSection>
        </div>
      </div>

      <!-- SIDEBAR -->
      <div class="column col-2">
        <div class="docs-block">
          <button class="btn btn-block btn-side" @click.prevent="openTemplateLink">View Template</button>
          <button v-if="!making && newDocumentId" @click.prevent="exportDoc('word')" class="btn btn-block btn-side" :class="{loading:exp_word}">Export Word</button>
          <button v-if="!making && newDocumentId" @click.prevent="exportDoc('pdf')" class="btn btn-block btn-side" :class="{loading:exp_pdf}">Export PDF</button>
          <button v-if="!making && newDocumentId" @click.prevent="showSendModal = true" class="btn btn-block btn-side">Dispatch</button>
          <button v-if="!making && newDocumentId" @click.prevent="openDocLink" class="btn btn-block btn-side docComplete">View</button>
          <button v-if="doc" @click.prevent="make" class="btn btn-block btn-side btn-primary" :class="{'loading': making}">Make</button>
        </div>
      </div>
    </div>

    <dispatchModal v-on:close="showSendModal = false"
                   :show="showSendModal"
                   :doc="doc"
                   :fileId="newDocumentId"
                   :user="user"></dispatchModal>

  </div>
</template>

<script>
import axios from 'axios'
import docMakerSection from '@/components/docs/docMakerSection'
import dispatchModal from '@/components/docs/dispatchModal'
import { bus } from '@/components/bus.js'

export default {
  name: 'makeDoc',
  components: {
    docMakerSection,
    dispatchModal
  },
  props: {
    type_id: String,
    matter_id: String
  },
  data () {
    return {
      template: null,
      doc: null, // converted from the template
      matter: null,
      user: null,
      making: false, // for spinner
      exp_word: false, // for spinner when exporting in word format
      exp_pdf: false,
      newDocumentId: null, // documentId of a newly made doc
      showResultsBox: false,
      showSendModal: false,
      formatter: new Intl.DateTimeFormat('en-AU', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZone: 'Australia/Sydney'
      })
    }
  },
  created: function () {
    this.getTemplate()
    this.getMatterAndUser()
  },
  mounted () {
    bus.$emit('in_editor', true) // inform the menu
  },
  destroyed () {
    bus.$emit('in_editor', false)
  },
  methods: {
    getTemplate () {
      axios.get('/api/docs/template/' + this.type_id).then(res => {
        if (res.data) {
          this.template = res.data
          this.loadTemplate(this.template)
          this.$root.$data.pageTitle = this.template.name
        }
      })
    },
    getMatterAndUser () {
      axios.get('/api/matters/matterAndUser/' + this.matter_id).then(res => {
        if (res.data) {
          this.matter = res.data.matter
          this.user = res.data.user
        }
      })
    },
    // Convert the Template object into a new DocumentState ready for viewing
    loadTemplate (t) {
      this.doc = {
        templateId: t.fileId,
        name: t.name,
        sections: t.sections.map(s => this.convertSection(s))
      }
    },
    // Convert a TemplateSection into a DocumentSection
    convertSection (section) {
      return {
        name: section.name,
        pretty_name: section.pretty_name,
        display: section.display,
        fields: section.fields.map(f => ({
          name: f.name,
          tag: f.tag,
          text: ''
        }))
      }
    },
    openDocLink () {
      window.open('https://docs.google.com/document/d/' + this.newDocumentId + '/edit', '_blank')
    },
    openTemplateLink () {
      window.open('https://docs.google.com/document/d/' + this.template.fileId + '/edit', '_blank')
    },
    getAffix () {
      // Make a timestamp affix for a filename: <filename> - YYYYMMDD
      let date = new Date()
      let parts = this.formatter.formatToParts(date)
      return ' - ' + parts[4].value + parts[0].value + parts[2].value
    },
    exportDoc (format) {
      // Set the right spinner in motion
      let flagFn = (str, bool) => {
        if (str === 'word') this.exp_word = bool
        if (str === 'pdf') this.exp_pdf = bool
      }
      flagFn(format, true)
      axios.post('/api/docs/download', {
        name: this.doc.name + this.getAffix(),
        fileId: this.newDocumentId,
        folderId: this.matter.folders['working_docs'],
        format: format
      }).then(res => {
        if (res.status === 200) {
          flagFn(format, false)
        }
      })
    },
    make () {
      if (!this.doc || !this.user || !this.matter) return
      if (!this.user.drive_root) return

      // Tags and their substitutions are two aligned arrays
      let removeSections = []
      let tags = []
      let subs = []

      for (var i = 0; i < this.doc.sections.length; i++) {
        let s = this.doc.sections[i]
        if (!s.display) {
          removeSections.push(s.name)
          continue
        }
        for (var j = 0; j < s.fields.length; j++) {
          let f = s.fields[j]
          if (!f.text) {
            continue
          }
          tags.push('{{' + f.tag + '}}')
          subs.push(f.text)
        }
      }

      // Add a tag for the date
      let date = new Date()
      tags.push('{{date_today}}')
      subs.push(this.formatter.format(date))

      this.making = true
      axios.post('/api/docs/makenewdoc', {
        document_name: this.doc.name + this.getAffix(),
        fileId: this.doc.templateId,
        // folderId: this.user.drive_root,
        folderId: this.matter.folders['working_docs'],
        tags: tags,
        substitutions: subs,
        removeSections: removeSections
      })
      .then(res => {
        if (res.status === 200) {
          this.making = false
          this.newDocumentId = res.data.documentId
          this.showResultsBox = true
        }
      })
      .catch(e => {
        this.making = false
        console.log(e.response.data)
      })
    }
  }
}
</script>

<style scoped>
.btn-side {
  margin-bottom:5px;
}
.btn.docComplete {
  background: #ffd16e;
}
</style>



// WEBPACK FOOTER //
// makeDoc.vue?49e732d2